import * as yup from 'yup'

const taxiRateSchema = yup.object().shape({
  areaGroupName: yup.string().required('Area group name is required'),
  vehicleTypeName: yup.string().required('Vehicle type is required'),
  minimumFare: yup.object().shape({
    price: yup.number(),
  }),
  additionalStops: yup.object().shape({
    price: yup.number(),
  }),
  waitAndReturn: yup.object().shape({
    discount: yup.number(),
    chargingPeriod: yup.object().shape({
      period: yup.number(),
      price: yup.number(),
    }),
  }),
  waitingTime: yup.object().shape({
    freePeriod: yup.number(),
    chargingPeriod: yup.object().shape({
      period: yup.number(),
      price: yup.number(),
    }),
    gracePeriod: yup.object().shape({
      period: yup.number(),
      price: yup.number(),
    }),
  }),
})

export default taxiRateSchema
